import {
  NullableSize,
  OuiBoxComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiTextComponent,
  OuiSymbolComponent,
} from '@aiz-gl/omni-ui';
import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-page',
  imports: [
    OuiRowComponent,
    OuiStackComponent,
    OuiTextComponent,
    OuiBoxComponent,
    OuiSymbolComponent,
    RouterLink,
  ],
  templateUrl: './page.html',
})
export class PageComponent {
  headline = input<string>('');
  breadcrumb = input<string>();
  breadcrumbLink = input<string>();
  headlinePaddingLeft = input<NullableSize>();
}
